import React, { useState, useEffect } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import { API_BASE_URL } from "../config";

function SerologyPage() {
  const [reports, setReports] = useState([]);
  const [form, setForm] = useState({
    id: null,
    name: "",
    ageSex: "",
    doctor: "",
    date: "",
    crp: "",
  });
  const [viewId, setViewId] = useState(null);

  const fetchReports = () => {
    axios
      .get(`${API_BASE_URL}/api/serology-reports`)
      .then((res) => setReports(res.data))
      .catch((err) => console.error("Error fetching reports:", err));
  };

  useEffect(() => {
    fetchReports();
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    if (form.id) {
      axios
        .put(`${API_BASE_URL}/api/serology-reports/${form.id}`, form)
        .then(() => {
          alert("Report Updated!");
          resetForm();
          fetchReports();
        })
        .catch(() => alert("Error updating report!"));
    } else {
      axios
        .post(`${API_BASE_URL}/api/serology-reports`, form)
        .then(() => {
          alert("Report Saved!");
          resetForm();
          fetchReports();
        })
        .catch(() => alert("Error saving report!"));
    }
  };

  const resetForm = () => {
    setForm({
      id: null,
      name: "",
      ageSex: "",
      doctor: "",
      date: "",
      crp: "",
    });
  };

  const handleEdit = (report) => {
    setForm(report);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this report?")) {
      axios
        .delete(`${API_BASE_URL}/api/serology-reports/${id}`)
        .then(() => fetchReports())
        .catch(() => alert("Error deleting report!"));
    }
  };

  const currentView = reports.find((r) => r.id === viewId);

  return (
    <div className="container my-3">
      <h2>📝 SEROLOGY REPORTS</h2>

      {/* Form */}
      <div className="my-4 border p-3 rounded bg-light">
        <h4>{form.id ? "✏️ Edit Report" : "➕ New Report"}</h4>

        <div className="row mb-2">
          <div className="col-md-6">
            <label>Pt. Name:</label>
            <input
              type="text"
              className="form-control"
              name="name"
              value={form.name}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-6">
            <label>Age/Sex:</label>
            <input
              type="text"
              className="form-control"
              name="ageSex"
              value={form.ageSex}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="row mb-2">
          <div className="col-md-6">
            <label>Ref. by Dr.:</label>
            <input
              type="text"
              className="form-control"
              name="doctor"
              value={form.doctor}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-6">
            <label>Date:</label>
            <input
              type="date"
              className="form-control"
              name="date"
              value={form.date}
              onChange={handleChange}
            />
          </div>
        </div>

        <h5>INVESTIGATION</h5>
        <div className="row mb-3">
          <div className="col-md-6">
            <label>CRP (Quantitative) (MG/L):</label>
            <input
              type="text"
              className="form-control"
              name="crp"
              value={form.crp}
              onChange={handleChange}
            />
            <small className="text-muted">Normal Range: UP TO 0-8 MG/L</small>
          </div>
        </div>

        <button className="btn btn-success me-3" onClick={handleSubmit}>
          💾 {form.id ? "Update" : "Save"}
        </button>

        <button className="btn btn-secondary" onClick={resetForm}>
          🧹 Clear
        </button>
      </div>

      {/* List */}
      <h4>Saved Reports</h4>
      <table className="table table-bordered">
        <thead>
          <tr>
            <th>ID</th>
            <th>Pt. Name</th>
            <th>Date</th>
            <th>Doctor</th>
            <th>CRP (MG/L)</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {reports.map((report) => (
            <tr key={report.id}>
              <td>{report.id}</td>
              <td>{report.name}</td>
              <td>{report.date}</td>
              <td>{report.doctor}</td>
              <td>{report.crp}</td>
              <td>
                <button
                  className="btn btn-sm btn-primary me-2"
                  onClick={() => handleEdit(report)}
                >
                  ✏️
                </button>
                <button
                  className="btn btn-sm btn-info me-2"
                  onClick={() => setViewId(report.id)}
                >
                  👁️
                </button>
                <button
                  className="btn btn-sm btn-danger"
                  onClick={() => handleDelete(report.id)}
                >
                  🗑️
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* View - shown below list */}
      {/* Print & Close Buttons (OUTSIDE print) */}
      {viewId && currentView && (
        <>
          {/* Print Area */}
          <div
            className="print-area"
            style={{
              fontFamily: "Arial, sans-serif",
              fontSize: "14px",
              color: "#000",
              padding: "10mm",
            }}
          >
            {/* Report Title */}
            <div
              style={{
                fontSize: "28px",
                fontWeight: "bold",
                textAlign: "center",
                marginBottom: "10px",
              }}
            >
              SEROLOGY REPORT
            </div>

            {/* Patient Info */}
            <table
              style={{
                width: "100%",
                marginBottom: "15px",
                border: "none",
                fontSize: "14px",
              }}
            >
              <tbody>
                <tr>
                  <td style={{ textAlign: "left", width: "50%" }}>
                    <strong>Pt. Name:</strong> {currentView.name}
                  </td>
                  <td style={{ textAlign: "right", width: "50%" }}>
                    <strong>Ref. by Dr.:</strong> {currentView.doctor}
                  </td>
                </tr>
                <tr>
                  <td style={{ textAlign: "left" }}>
                    <strong>Age/Sex:</strong> {currentView.ageSex}
                  </td>
                  <td style={{ textAlign: "right" }}>
                    <strong>Date:</strong> {currentView.date}
                  </td>
                </tr>
              </tbody>
            </table>

            {/* Investigation Title */}
            <div
              style={{
                fontSize: "20px",
                fontWeight: "bold",
                textDecoration: "underline",
                marginTop: "10px",
                marginBottom: "10px",
              }}
            >
              INVESTIGATION
            </div>

            {/* Investigation Table */}
            <table
              className="table table-bordered"
              style={{
                width: "100%",
                borderCollapse: "collapse",
              }}
            >
              <thead>
                <tr>
                  <th>Test</th>
                  <th>Result</th>
                  <th>Normal Range</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>CRP (Quantitative)</td>
                  <td>{currentView.crp} MG/L</td>
                  <td>UP TO 0-8 MG/L</td>
                </tr>
              </tbody>
            </table>

            {/* Interpretation */}
            <div
              style={{
                fontSize: "20px",
                fontWeight: "bold",
                textDecoration: "underline",
                marginTop: "10px",
                marginBottom: "10px",
              }}
            >
              INTERPRETATION
            </div>

            <p style={{ textAlign: "justify" }}>
              C-Reactive protein (CRP) is an acute phase reactant protein that
              has the property of showing elevations in concentration in
              response to stressful or inflammatory states that occur with
              infection, injury, surgery, trauma or tissue necrosis. <br />
              It falls quickly after resolution of inflammation since its
              half-life is 6 hours. The main limitation of CRP is in its
              non-specific response and should not be interpreted without a
              complete clinical history and evaluation.
            </p>

            {/* Footer */}
            <p className="text-center mt-4">
              <strong>*****END OF REPORT*****</strong> &nbsp;&nbsp;&nbsp;&nbsp;
              Technologist
            </p>
          </div>
          <button
            className="no-print btn btn-primary my-3 me-3"
            onClick={() => window.print()}
          >
            🖨️ Print
          </button>
        </>
      )}
    </div>
  );
}

export default SerologyPage;
